"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreeFinancialRequest = void 0;
var AgreeFinancialRequest = /** @class */ (function () {
    function AgreeFinancialRequest() {
    }
    return AgreeFinancialRequest;
}());
exports.AgreeFinancialRequest = AgreeFinancialRequest;
;
//# sourceMappingURL=agreeFinancial.request.js.map